<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">12</h2>
<p class="vers"><span>Die Zeit</span>, die meine
Reise braucht,<br class="calibre1"/>
ist lang, und der Weg ist lang.</p>
<p class="vers">Ich kam heraus auf dem Wagen im<br class="calibre1"/>
ersten Strahle des Lichts und setzte die<br class="calibre1"/>
Fahrt weiter fort durch die Wildnis der<br class="calibre1"/>
Welten und ließ meine Spur auf manchem<br class="calibre1"/>
Stern und Planeten.</p>
<p class="vers">Es ist der fernste Weg, der am nächsten<br class="calibre1"/>
führt zu dir selbst, und jene Übung<br class="calibre1"/>
ist die schwierigste, die zum allereinfachsten<br class="calibre1"/>
Ton kommt.</p>
<p class="vers">An jede fernste Türe muß der Wanderer<br class="calibre1"/>
klopfen, bis er zur eigenen gelangt,<br class="calibre1"/>
durch alle äußeren Welten muß man ziehn,<br class="calibre1"/>
zuletzt zum Allerheiligsten zu kommen.</p>
<p class="vers">Und meine Augen streiften weit und<br class="calibre1"/>
breit, eh ich sie schloß und sprach: »Hier<br class="calibre1"/>
bist du!« <a id="page16" title="mabarosa/wedi"></a></p>
<p class="vers">Die Frage und der Ruf: »O wo?« zerschmilzt<br class="calibre1"/>
in tausend Tränenströmen und<br class="calibre1"/>
ertränkt die Welt mit der Flut der Versichrung<br class="calibre1"/>
»Ich bin«! <a id="page17" title="mabarosa/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0013.vue?dcaf2bc8